"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jquery = _interopRequireDefault(require("jquery"));

var _backbone = _interopRequireDefault(require("backbone"));

var _underscore = _interopRequireDefault(require("underscore"));

var _handlebars = _interopRequireDefault(require("handlebars"));

var _moment = _interopRequireDefault(require("moment"));

var _config = _interopRequireDefault(require("config"));

var _filePicker = _interopRequireDefault(require("filePicker"));

var _countryList = require("@bizzabo/country-list");

require("datetimepicker");

var _states = _interopRequireDefault(require("states"));

var filestack = _interopRequireWildcard(require("filestack-js"));

var _ticket_field_view = _interopRequireDefault(require("hbars!../templates/ticket_field_view"));

var _form_field_view = _interopRequireDefault(require("hbars!../templates/form_field_view"));

var _country_select_options = _interopRequireDefault(require("hbars!../templates/country_select_options"));

var _rsvp = _interopRequireDefault(require("hbars!../templates/rsvp"));

var _FeatureToggleUtils = _interopRequireDefault(require("../utils/FeatureToggleUtils"));

var _FormField = require("../constants/FormField");

var _AccountImageView = _interopRequireDefault(require("./AccountImageView"));

var _FormViewMixin = _interopRequireDefault(require("./FormViewMixin"));

var _uploader = require("../../bizzabo-components/utils/uploader");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

_handlebars.default.registerPartial('country_select_options', _country_select_options.default);

_handlebars.default.registerPartial('form_field_view', _form_field_view.default);

_handlebars.default.registerPartial('rsvp', _rsvp.default); // 100MB


var maxSize = 100 * 1024 * 1024;

var FormFieldView = _backbone.default.View.extend({
  viewDateFormat: 'MM/DD/YYYY',
  events: function events() {
    return {
      'ifChanged [type="checkbox"]': 'checkboxChanged',
      'click .upload-file-action': 'uploadFileClicked',
      'click .icon-trash': 'removeAccountImage',
      'click [data-upload-file="true"]': 'onUploadFileClicked',
      'click .js-clear-upload': 'onRemoveFileClicked'
    };
  },
  initialize: function initialize() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.inFormView = options.inFormView;
    this.separators = options.separators || [];
    this.layout = options.layout || 6;
    this.editRegistration = options.editRegistration;
    this.ticketId = options.ticketId;
    this.entities = options.entities || new _backbone.default.Collection();
    this.fileUploadModalId = options.fileUploadModalId || '';
    this.filepicker = _filePicker.default;
    this.filestack = filestack;
    this.tagName = this.inFormView ? '' : 'li';
    this.className = this.inFormView || this.model.get('attributeKey') === 'sessionRegistration' ? '' : 'ticket-form-field xxs-field col-xs-9 col-sm-8';
    this.optimizeViewForChrome = options.optimizeViewForChrome;
    this.isCloudinaryInlineContainer = _FeatureToggleUtils.default.isFeatureEnabled('cloudinaryInlineContainer');
    this.IBMBannedCountries = options.IBMBannedCountries;
    this.setupModelValidation();
    this.initializeLocalValues();
  },
  setEventCountries: function setEventCountries(countries) {
    this.model.set('eventCountries', countries);
    this.render();
  },
  sanitiseBlacklistedCountries: function sanitiseBlacklistedCountries() {
    var blacklistedCountries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return blacklistedCountries.filter(function (country) {
      return country === null || country === void 0 ? void 0 : country.value;
    });
  },
  onRemoveFileClicked: function onRemoveFileClicked(e) {
    this.model.unset('localValues');
  },
  onFilePickerUpload: function onFilePickerUpload(e) {
    var thisView = this;

    var success = function success(blobs) {
      var blob = blobs[0];
      var s3FilesUploadURL = "https://s3.amazonaws.com/".concat(_config.default.s3FilesUploadBucket, "/").concat(encodeURIComponent(blob.key));
      thisView.model.set('localValues', s3FilesUploadURL);
      thisView.$('.js-file-name').text(blob.key);
    };

    var error = function error(FPError) {
      var userClosedPicker = FPError.code != 101;

      if (userClosedPicker) {
        _backbone.default.trigger('triggerNotification', {
          message: 'File upload failed.',
          type: 'error',
          showCloseButton: true
        });
      }
    };

    this.filepicker.setKey(_config.default.filepickerApiKey);
    this.filepicker.pickAndStore({
      container: 'modal',
      services: ['COMPUTER'],
      maxSize: maxSize,
      multiple: false
    }, {
      location: 'S3',
      container: _config.default.s3FilesUploadBucket,
      access: 'public'
    }, success, error);
  },
  onFilestackUpload: function () {
    var _onFilestackUpload = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(e) {
      var _this = this;

      var fromSources, filepickerApiKey, s3FilesUploadBucket, upload, result, key, s3FilesUploadURL, userClosedPicker;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              fromSources = ['local_file_system'];
              filepickerApiKey = _config.default.filepickerApiKey, s3FilesUploadBucket = _config.default.s3FilesUploadBucket;

              upload = function upload() {
                var client = _this.filestack.init(filepickerApiKey);

                return new Promise(function (resolve, reject) {
                  var optionalParams = _this.fileUploadModalId ? {
                    rootId: _this.fileUploadModalId
                  } : {};

                  var _pickerOptions = _objectSpread({
                    onUploadDone: function () {
                      var _onUploadDone = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response) {
                        var uploadedFile;
                        return regeneratorRuntime.wrap(function _callee$(_context) {
                          while (1) {
                            switch (_context.prev = _context.next) {
                              case 0:
                                uploadedFile = (response === null || response === void 0 ? void 0 : response.filesUploaded[0]) || {};

                                if (!(uploadedFile && !uploadedFile.key)) {
                                  _context.next = 5;
                                  break;
                                }

                                _context.next = 4;
                                return (0, _uploader.getAssetKey)({
                                  handle: uploadedFile.handle,
                                  getMetadata: client.metatada.bind(client)
                                });

                              case 4:
                                uploadedFile.key = _context.sent;

                              case 5:
                                resolve(response);

                              case 6:
                              case "end":
                                return _context.stop();
                            }
                          }
                        }, _callee);
                      }));

                      function onUploadDone(_x2) {
                        return _onUploadDone.apply(this, arguments);
                      }

                      return onUploadDone;
                    }(),
                    onFileUploadFailed: reject,
                    onCancel: reject,
                    storeTo: {
                      location: 'S3',
                      access: 'public',
                      region: 'us-east-1',
                      container: s3FilesUploadBucket
                    },
                    accept: _FormField.MIME_TYPES,
                    fromSources: fromSources,
                    maxSize: maxSize
                  }, optionalParams);

                  client.picker(_pickerOptions).open(resolve, reject);
                });
              };

              _context2.prev = 3;
              _context2.next = 6;
              return upload();

            case 6:
              result = _context2.sent;
              key = result.filesUploaded[0].key;
              s3FilesUploadURL = "https://s3.amazonaws.com/".concat(s3FilesUploadBucket, "/").concat(encodeURIComponent(key));
              this.model.set('localValues', s3FilesUploadURL);
              this.$('.js-file-name').text(key);
              _context2.next = 17;
              break;

            case 13:
              _context2.prev = 13;
              _context2.t0 = _context2["catch"](3);
              userClosedPicker = (_context2.t0 === null || _context2.t0 === void 0 ? void 0 : _context2.t0.code) != 101;

              if (userClosedPicker) {
                _backbone.default.trigger('triggerNotification', {
                  message: 'File upload failed.',
                  type: 'error',
                  showCloseButton: true
                });
              }

            case 17:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this, [[3, 13]]);
    }));

    function onFilestackUpload(_x) {
      return _onFilestackUpload.apply(this, arguments);
    }

    return onFilestackUpload;
  }(),
  onUploadFileClicked: function onUploadFileClicked(e) {
    var restrictFileTypeEnabled = _FeatureToggleUtils.default.isFeatureEnabled('restrictFileType');

    if (restrictFileTypeEnabled) {
      this.onFilestackUpload(e);
    } else {
      this.onFilePickerUpload(e);
    }
  },
  remove: function remove() {
    this.imageView && this.imageView.remove();
    return _backbone.default.View.prototype.remove.call(this);
  },
  setupModelValidation: function setupModelValidation() {
    this.initFieldType();
  },
  initializeLocalValues: function initializeLocalValues() {
    var localValues;
    var submissionValues = this.model.get('submissionValues');
    var isCountry = this.model.get('attributeKey') === 'country';

    if (this.model.get('entityType') == 'radio' || isCountry) {
      localValues = submissionValues && submissionValues[0];
    } else {
      localValues = submissionValues;
    }

    localValues && this.model.set('localValues', localValues);
  },
  initFieldType: function initFieldType() {
    var systemFieldType = this.model.get('systemFieldType');

    switch (systemFieldType) {
      case 'state':
        this.listenTo(_backbone.default, "countryChanged:".concat(this.ticketId), this.updateStates);
        break;

      case 'country':
        {
          var _this$model$get;

          this.listenTo(_backbone.default, 'event-countries-fetched', this.setEventCountries);
          var blacklistedCountries = (_this$model$get = this.model.get('values')) === null || _this$model$get === void 0 ? void 0 : _this$model$get.toJSON();

          if (blacklistedCountries !== null && blacklistedCountries !== void 0 && blacklistedCountries.length) {
            this.model.set('countryExceptions', this.sanitiseBlacklistedCountries(blacklistedCountries));
          }

          this.listenTo(this.model, 'change:localValues', this.triggerCountryChange);
          this.model.set('isCountry', true);
          break;
        }

      default:
        break;
    }
  },
  triggerCountryChange: function triggerCountryChange() {
    var countryName = this.model.get('localValues');
    var countryCode = (0, _countryList.getCountryCode)(countryName) || '';
    this.model.set('countryCode', countryCode);

    _backbone.default.trigger("countryChanged:".concat(this.ticketId), countryName);
  },
  updateStates: function updateStates(countryName) {
    var states = _states.default.Countries.find(function (countryObj) {
      return countryObj.n === countryName;
    });

    var selectEl = this.$('select.js-state-select');
    var selectWithBootstrapSelectPickerEl = this.$('select.js-state-select.selectpicker');
    var inputEl = this.$('input[type="text"]');
    var bootstrapStatesSelectEl = this.$('div.js-state-select');

    if (!this.selectedCountry && countryName) {
      this.selectedCountry = countryName;
    }

    if (this.selectedCountry !== countryName) {
      var _this$model;

      (_this$model = this.model) === null || _this$model === void 0 ? void 0 : _this$model.set('localValues', '');
      this.selectedCountry = countryName;
    }

    if (states) {
      var _this$model2, _this$model3, _states$s;

      selectEl.empty();
      selectEl.append((0, _jquery.default)('<option></option>').attr('value', '').text('Select Option'));

      _underscore.default.each(states.s, function (state) {
        selectEl.append((0, _jquery.default)('<option></option>').attr('value', state.n).text(state.n));
      }, this);

      _underscore.default.defer(function () {
        selectWithBootstrapSelectPickerEl.selectpicker('refresh');
      });

      var localValues = (_this$model2 = this.model) === null || _this$model2 === void 0 ? void 0 : _this$model2.get('localValues');
      var selectedStateName = Array.isArray(localValues) ? (_this$model3 = this.model) === null || _this$model3 === void 0 ? void 0 : _this$model3.get('localValues')[0] : localValues;
      selectEl.find("option[value=\"".concat(selectedStateName, "\"]")).attr('selected', true);
      var stateDoesntExist = !(states !== null && states !== void 0 && (_states$s = states.s) !== null && _states$s !== void 0 && _states$s.find(function (_ref) {
        var n = _ref.n;
        return n === selectedStateName;
      }));

      if (stateDoesntExist) {
        var _this$model4;

        (_this$model4 = this.model) === null || _this$model4 === void 0 ? void 0 : _this$model4.set('localValues', '');
      }
    } else {
      var _this$model5;

      inputEl.val((_this$model5 = this.model) === null || _this$model5 === void 0 ? void 0 : _this$model5.get('localValues'));
    }

    inputEl.toggleClass('hide', !!states);
    selectEl.toggleClass('hide', !states);
    bootstrapStatesSelectEl.toggleClass('hide', !states);
  },
  renderCheckboxes: function renderCheckboxes() {
    var values = this.model.get('localValues');

    _underscore.default.each(values, function (value) {
      this.$('[value="' + value + '"]').prop('checked', true);
      this.$('[value="' + value + '"]').icheck('updated');
    }, this);
  },
  checkboxChanged: function checkboxChanged() {
    var submissionValues = [];

    _underscore.default.each(this.$('[type="checkbox"]'), function (checkbox) {
      if (this.model.get('attributeKey') === 'sessionRegistration') {
        return;
      }

      if ((0, _jquery.default)(checkbox).is(':checked')) {
        submissionValues.push((0, _jquery.default)(checkbox).val());
      } else {
        if (this.model.get('entityType') === 'waiver') {
          submissionValues.push(false);
        }
      }
    }, this);

    if (submissionValues.length === 0) {
      submissionValues.push(null);
    }

    this.model.set('localValues', submissionValues);
  },
  viewTransformers: {
    localValues: function localValues(value) {
      var entityType = this.model.get('entityType');
      var isDate = entityType === 'date';
      var isUtcDate = entityType === 'utcDate';
      var isEmptyField = value === '_';

      if (isDate) {
        return isEmptyField ? undefined : _moment.default.utc(value, this.viewDateFormat).valueOf();
      }

      if (isUtcDate) {
        return isEmptyField ? undefined : (0, _moment.default)(value, this.viewDateFormat).format('YYYY-MM-DD');
      }

      return value;
    }
  },
  modelTransformers: {
    localValues: function localValues(value) {
      switch (this.model.get('entityType')) {
        case 'date':
          {
            var date = parseInt(value);

            if (date) {
              return _moment.default.utc(date).format(this.viewDateFormat);
            }

            return;
          }

        case 'utcDate':
          {
            var _date = value && (0, _moment.default)(value);

            if (_date !== null && _date !== void 0 && _date.isValid()) {
              return _date.format(this.viewDateFormat);
            }

            return;
          }

        case 'file':
          {
            return this.convertFileName(value);
          }

        default:
          {
            return value;
          }
      }
    }
  },
  renderMultiCheckbox: function renderMultiCheckbox() {
    var multiselectContainers = document.querySelectorAll('.multiselect-container');
    multiselectContainers.forEach(function (container) {
      container.style.maxHeight = '230px'; // Set your desired max-height value
    });
  },
  renderDatePickers: function renderDatePickers() {
    this.$('input[name="localValues"]').attr('placeholder', 'mm/dd/yyyy');
    this.$('input[name="localValues"]').datetimepicker({
      format: 'm/d/Y',
      timepicker: false,
      closeOnDateSelect: true,
      scrollInput: false
    });
  },
  imageChanged: function imageChanged() {
    var localValues = this.model.get('localValues');
    var src = Array.isArray(localValues) && !localValues.length ? '' : localValues;
    src && this.$('.error-localValues').empty();
    this.$('.upload-file-action').attr('disabled', !!src);
    this.$('.image-upload-result').attr('src', src).toggleClass('hide', !src);
  },
  fileChanged: function fileChanged() {
    var src = this.model.get('localValues');

    if (src) {
      this.$('.error-localValues').empty();
    }

    this.$('[data-upload-file="true"]').toggleClass('hide', !!src);
    this.$('.js-file-name').toggleClass('hide', !src);
    this.$('.js-clear-upload').toggleClass('hide', !src);
  },
  renderFile: function renderFile() {
    this.listenTo(this.model, 'change:localValues', this.fileChanged);
    this.fileChanged();
  },
  renderImage: function renderImage() {
    this.listenTo(this.model, 'change:localValues', this.imageChanged);
    this.imageChanged();
    this.initializeUploadCloudinaryView();
  },
  initializeUploadCloudinaryView: function initializeUploadCloudinaryView() {
    var isProfileImage = this.model.get('attributeKey') === 'thumbnailUrl';

    var cloudinaryOptions = _objectSpread(_objectSpread({
      maxImageWidth: 750,
      showPoweredBy: false
    }, this.isCloudinaryInlineContainer && {
      inlineContainer: '#cloudinary_wrap'
    }), isProfileImage && {
      croppingAspectRatio: 0.99999,
      showSkipCropButton: false
    });

    this.imageView = new _AccountImageView.default({
      cloudinaryOptions: cloudinaryOptions
    });
    this.listenTo(this.imageView, 'success', this.uploadFileClicked);
  },
  convertFileName: function convertFileName(fileName) {
    if (!fileName) {
      return;
    }

    var filePath = decodeURIComponent(fileName);
    var arr = filePath && filePath.split('/');
    var name = arr && arr.length && arr[arr.length - 1];
    var num = name && name.indexOf('_');

    if (!name) {
      return;
    }

    return name.substring(num + 1);
  },
  setCloudinaryWrapperVisiblity: function setCloudinaryWrapperVisiblity() {
    var isVisible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (!this.isCloudinaryInlineContainer) {
      return;
    }

    this.$('#cloudinary_wrap').toggleClass('hide', !isVisible);
  },
  uploadFileClicked: function uploadFileClicked() {
    var _this2 = this;

    this.setCloudinaryWrapperVisiblity(true);
    this.$('.account-image-remove-container').removeClass('hide');

    var success = function success() {
      _this2.model.set('localValues', _this2.imageView.image);

      _this2.$('.error-localValues').empty();

      _this2.setCloudinaryWrapperVisiblity(false);

      _this2.imageView.close();
    };

    var error = function error() {
      _this2.$('.error-localValues').text(error.message);
    };

    this.imageView.uploadImage({
      success: success,
      error: error
    });
  },
  removeAccountImage: function removeAccountImage(e) {
    this.model.unset('localValues');
    this.$('.center-image').addClass('hide');
    this.$('.account-image-remove-container').addClass('hide');
    e.stopPropagation();
  },
  getTemplate: function getTemplate() {
    return this.inFormView ? _form_field_view.default : _ticket_field_view.default;
  },
  getIsHidden: function getIsHidden() {
    var UTM = ['utmSource', 'utmMedium', 'utmCampaign', 'utmTerm', 'utmContent'];

    if (UTM.includes(this.model.get('attributeKey'))) {
      return true;
    }

    return false;
  },
  render: function render() {
    var returnedTemplate = this.getTemplate();
    this.$el.html(returnedTemplate(_underscore.default.extend(this.model.toJSON(), {
      layout: this.layout,
      editRegistration: this.editRegistration,
      optimizeViewForChrome: this.optimizeViewForChrome,
      IHSRemoveSanctionedCountries: _FeatureToggleUtils.default.isFeatureEnabled('IHSRemoveSanctionedCountries'),
      IBMBannedCountries: this.IBMBannedCountries,
      hidden: this.getIsHidden()
    })));
    this.$el.addClass(this.className);
    this.initValidation({
      attrs: ['localValues'],
      tracking: false,
      trackModels: [this.model],
      handleSave: false,
      enhance: {
        multiselect: true
      }
    });
    this.renderForm();
    var entityType = this.model.get('entityType');

    switch (entityType) {
      case 'bool':
      case 'checkbox':
        this.renderCheckboxes();
        break;

      case 'waiver':
        this.renderCheckboxes();
        this.checkboxChanged();
        break;

      case 'date':
        this.renderDatePickers();
        break;

      case 'utcDate':
        this.renderDatePickers();
        break;

      case 'image':
        this.renderImage();
        break;

      case 'file':
        this.renderFile();
        break;

      case 'checkboxselect':
        this.renderMultiCheckbox();
        break;

      default:
        break;
    }

    var systemFieldType = this.model.get('systemFieldType');

    if (systemFieldType === 'state') {
      var countryEl = this.entities.findWhere && this.entities.findWhere({
        systemFieldType: 'country'
      });

      if (countryEl) {
        var countryName = countryEl.get('localValues');

        _backbone.default.trigger("countryChanged:".concat(this.ticketId), countryName);
      }
    }

    return this;
  }
});

_underscore.default.extend(FormFieldView.prototype, _FormViewMixin.default);

var _default = FormFieldView;
exports.default = _default;